<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <v-btn
        v-if="!$route.meta.hideClara && claraDisponivel"
        icon
        class="clara-launcher"
        :class="launcherClass"
        data-test="btn-ai-assistant"
        :aria-label="launcherAriaLabel"
        :aria-pressed="String(isOpen)"
        v-bind="attrs"
        v-on="on"
        @click="toggle"
      >
        <PhSparkle
          :size="18"
          :weight="sparkleWeight"
        />
      </v-btn>
    </template>
    <span>{{ launcherTooltip }}</span>
  </v-tooltip>
</template>

<script>
// Store
import { OPTIONS_STORE_CLARA } from '@/vuex/module/clara';

// Utils
import { claraDisponivelPara } from '@/views/clara/claraAccess';

export default {
  name: 'ClaraLauncher',

  inject: {
    appData: { default: () => ({}) }
  },

  computed: {
    claraDisponivel() {
      return claraDisponivelPara(this.appData.currentUser);
    },

    isOpen() {
      return this.$store.getters[OPTIONS_STORE_CLARA.GETTERS.IS_OPEN];
    },

    launcherClass() {
      return { 'clara-launcher--on': this.isOpen };
    },

    launcherAriaLabel() {
      return this.isOpen ? this.$t('clara.launcher.closeLabel') : this.$t('clara.launcher.openLabel');
    },

    sparkleWeight() {
      return this.isOpen ? 'fill' : 'regular';
    },

    launcherTooltip() {
      return this.isOpen ? this.$t('clara.launcher.closeLabel') : this.$t('clara.launcher.openTooltip');
    }
  },

  methods: {
    toggle() {
      this.$store.commit(OPTIONS_STORE_CLARA.MUTATIONS.TOGGLE);
    }
  }
};
</script>

<style scoped>
.clara-launcher.v-btn.v-btn--icon {
  color: var(--clara-text) !important;
  transition: background-color var(--tc-transition), box-shadow var(--tc-transition);
}

.clara-launcher--on.v-btn.v-btn--icon {
  box-shadow: inset 0 0 0 1px var(--clara-brand) !important;
}

.clara-launcher.v-btn:not(.clara-launcher--on) {
  animation: clara-respirar 3.2s ease-in-out infinite;
}

@keyframes clara-respirar {
  0%,
  100% {
    box-shadow: 0 0 0 0 transparent;
  }
  50% {
    box-shadow: 0 0 0 3px var(--clara-tint);
  }
}

@media (prefers-reduced-motion: reduce) {
  .clara-launcher.v-btn:not(.clara-launcher--on) {
    animation: none;
  }
}
</style>
